/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// class LazySection extends HTMLElement {
//   static sectionsToFetch = [];

//   constructor() {
//     super();

//     this.section = this.closest('section')?.id || this.closest('[id]').id;
//     this.section = this.section?.replace('shopify-section-', '');

//     this.trigger = this.dataset.triggerEvent || 'intersection-observer';
//     this.targetSelector = this.dataset.triggerTarget || 'body';

//     this.boundHandleMouseover = this.handleMouseover.bind(this);
//     this.boundHandleClick = this.handleClick.bind(this);

//     if (!this.classList.contains('section-loaded')) {
//       this.fetchSections();
//       this.classList.add('section-loaded');
//     }
//   }

//   connectedCallback() {
//     const targetElement = document.querySelector(this.targetSelector);
    
//     // Initialize Hulkapp wishlist
//     setTimeout(function() { HulkappWishlist?.init(); }, 3000);

//     // Different triggers based on data-trigger attribute
//     if (this.trigger === 'mouseover') {
//       if (screen.width < 990) return;

//       targetElement.addEventListener('mouseover', this.boundHandleMouseover);
//     } else if (this.trigger === 'click') {
//       targetElement.addEventListener('click', this.boundHandleClick);
//     } else {
//       // Default to intersection observer
//       new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
//     }
//   }

//   // Handler for intersection-observer trigger
//   handleIntersection(entries, observer) {
//     if (!entries[0].isIntersecting) return;
//     observer.unobserve(this);

//     if (!this.classList.contains('section-loaded')) {
//       this.fetchSections();
//       this.classList.add('section-loaded');
//     }
//   }

//   // Handler for mouseover trigger
//   handleMouseover() {
//     // Remove trigger once added to sectionsToFetch
//     this.removeTrigger();
//     if (!this.classList.contains('section-loaded')) {
//       this.fetchSections();
//       this.classList.add('section-loaded');
//     }
//   }

//   // Handler for click trigger
//   handleClick() {
//     // Remove trigger once added to sectionsToFetch
//     this.removeTrigger();
//     if (!this.classList.contains('section-loaded')) {
//       this.fetchSections();
//       this.classList.add('section-loaded');
//     }
//   }

//   // Common function for fetching sections
//   fetchSections() {
//     LazySection.sectionsToFetch.push(this.section);
//     const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

//     // Check if there is an ongoing network request
//     if (LazySection.abortController) {
//       LazySection.abortController.abort();
//     }

//     LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

//     fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
//       .then((response) => response.json())
//       .then((json) => {
//         for (const [key, value] of Object.entries(json)) {
//           const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

//           if (sectionContent && sectionContent.innerHTML.trim().length) {
//             const section = document.getElementById('shopify-section-' + key);
//             section.innerHTML = sectionContent.innerHTML;

//             // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//             section.querySelectorAll('script').forEach((oldScriptTag) => {
//               const newScriptTag = document.createElement('script');
//               Array.from(oldScriptTag.attributes).forEach((attribute) => {
//                 newScriptTag.setAttribute(attribute.name, attribute.value);
//               });
//               newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//               oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//             });

//             //Re-initialize flickity and rest of the functionality
//             window.theme("*")
//           }
//         }

//         // Initialize Hulkapp wishlist
//         setTimeout(function() { HulkappWishlist?.init(); }, 3000);

//         if (sectionsToFetchBatch.length < 5)
//           LazySection.sectionsToFetch = [];
//       })
//       .catch((e) => {
//         console.warn(e);
//       });
//   }

//   // Remove trigger based on data-target attribute
//   removeTrigger() {
//     const targetElement = document.querySelector(this.targetSelector);

//     if (targetElement) {
//       targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
//       targetElement.removeEventListener('click', this.boundHandleClick);
//     }
//   }
// }

// customElements.define('lazy-section', LazySection);


function showProductPopUp(productType) {
  const productPopUpContainer = document.querySelector(`.product-atc-confirm[data-product-type="${productType}"]`);
  productPopUpContainer?.classList.add('show_popup');
  document.querySelector('body')?.classList.add('overflow-hidden', 'js-drawer-open');

}


document.addEventListener('click', (e) => {
  console.log("clickedddddd")
  if (e.target.matches('.product-atc-confirm button')) {
    confirmATC(e)
  }
  if (e.target.matches('.product-atc-confirm .close_button')) {
    hideProductPopup(e);
  }

  if(e.target.closest('.popup-quick-view__wrapper .main-product__swatch-button')) {
    AjaxinateQuickViewProduct(e);
  }

  const videoPopups = document.querySelectorAll('[data-show-video-popup="true"]');

  // this will trigger the video popup
  const target = Array.from(videoPopups).find(popup => e.target.matches(`${popup.getAttribute('data-target')}`));
  if (target) {
    e.preventDefault();
    const dataTargetValue = target.getAttribute('data-target');
    const videoSection = document.querySelector(`[data-target="${dataTargetValue}"]`)
    videoSection?.classList.add('video-popup');
    videoSection?.classList.remove('d-none')
    const video = videoSection.querySelector('video');

    if (video && video.paused) video.play();


    document.body.classList.add('overflow-hidden', 'js-drawer-open');
  }

  if (e.target.matches('.video-close-button') || e.target.matches('.video-close-button svg')) {

    document.body.classList.remove('overflow-hidden', 'js-drawer-open');

    // Pause the video in the closest section if it is playing
    const section = e.target.closest('section');
    if (section) {
      const video = section.querySelector('video');
      if (video && !video.paused) {
        video.pause();
      }
    }
    section?.classList.add('d-none');
    document.querySelector('[data-show-video-popup="true"].video-popup').classList.remove('video-popup');
  }


  if (e.target.matches('.swatch__button')) {
    let currentCollectionHandle = e.target.closest('.product-grid-item__info')?.dataset?.currentCollectionHandle;
    e.preventDefault();
    fetchProductData(e.target , false , currentCollectionHandle);
  }
});

function AjaxinateQuickViewProduct(e) {
  e.preventDefault();
  const target = e.target;
  const productUrl = target?.closest('.product-variant-options')?.getAttribute('href');
  const url = `${productUrl}?view=quick-view`;

  if ( target.querySelector('.product-variant-options.selected') || target.querySelector('.product-variant-options .selected')) {
    return;
  }

  fetch(url)
    .then(response => response.text())
    .then(data => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const quickViewWrapper = target.closest('.popup-quick-view__wrapper')
      const quickViewProduct = html.querySelector('.popup-quick-view__body__inner');
      const quickViewFoot = html.querySelector('.popup-quick-view__foot');
      const quickViewViewDetails = html.querySelector('.popup-quick-view__view-button');
      target.closest('.popup-quick-view__body__inner').innerHTML = quickViewProduct.innerHTML;
      quickViewWrapper.querySelector('.popup-quick-view__foot').innerHTML = quickViewFoot.innerHTML;
      quickViewWrapper.querySelector('.popup-quick-view__view-button').innerHTML = quickViewViewDetails.innerHTML;
      
      if(window.innerWidth < 768) {
      const ajaxEvent = new CustomEvent('ajax:init:gallary');
      document.dispatchEvent(ajaxEvent);
      }
      const ajaxEvent = new CustomEvent('ajax:init:zoom');
        document.dispatchEvent(ajaxEvent);
      })
    .catch(error => {
      console.error('Error fetching or parsing data:', error);
      window.location.href = productUrl;
    });
}

function confirmATC(e) {
  e.preventDefault();
  const addToCartButton = e.target.closest('.product-single__details').querySelector('.product__submit__item button');
  addToCartButton.setAttribute('data-atc', 'true');
  e.target.closest('.product-atc-confirm').classList.remove('show_popup');
  document.body.classList.remove('overflow-hidden', 'js-drawer-open');
  addToCartButton.click();
}

function hideProductPopup(e) {
  e.preventDefault();
  e.target?.closest('.product-atc-confirm')?.classList.remove('show_popup');
  document.querySelector('body')?.classList.remove('overflow-hidden', 'js-drawer-open');
}

//on page it remove the href for target element, that is add in the video section
document.addEventListener("DOMContentLoaded", () => {
  const videoPopupEl = document.querySelectorAll('[data-show-video-popup="true"]');
  videoPopupEl.forEach((each) => {
    const targetEl = each.getAttribute('data-target');
    document.querySelectorAll(targetEl).forEach((target) => {
      target.removeAttribute('href')
    });
  });
});

//showing product as variants in product card
//on click of color swatches the prouduct will update with the new product
function fetchProductData(target, sizeOption , collectionHandle) {
  const productHandle = target.dataset.productHandle;

  const isAdaniOfferPage = document.body.classList.contains('collection-template-adani_offer');
  const isAdaniOfferPlatinumPage = document.body.classList.contains('collection-template-adani-offer-platinum');

  const isAdaniTemplate = document.body.classList.contains("adani_offer")

  // Determine the view parameter based on collection suffix
  let viewParam = 'card';
  if (isAdaniOfferPlatinumPage ) {
    viewParam = 'adani-offer-platinum';
  } else if (isAdaniOfferPage || isAdaniTemplate) {
    viewParam = `adani-offer&colHandle=${collectionHandle}`;
  }

  const productUrl = `/products/${productHandle}?view=${viewParam}`;
  const container = target?.closest('.product-grid-item');
  if (target.getAttribute('aria-selected') === 'true') return;
  if (!productHandle || !container) return;

  fetch(productUrl)
    .then((response) => response.text())
    .then((data) => {
      // this will update product card except color swatches
      const html = new DOMParser().parseFromString(data, "text/html");

      // For adani-offer pages, additional collection check
      if (isAdaniOfferPage || isAdaniOfferPlatinumPage) {
        const currentCollectionHandle = document.querySelector('[data-collection-handle]')?.dataset.collectionHandle;
        const productCollections = html.querySelector('[data-product-collections]')?.dataset.productCollections;

        if (productCollections && currentCollectionHandle) {
          const collectionsArray = JSON.parse(productCollections);
          if (!collectionsArray.includes(currentCollectionHandle)) {
            console.log('Product not in current collection:', productHandle);
            return;
          }
        }
      }
      container.querySelector('.product__media__container').innerHTML = html.querySelector(".product__media__container").innerHTML;
      container.querySelector('.product-grid-item__title').innerHTML = html.querySelector(".product-grid-item__title").innerHTML;
      container.querySelector('.product-grid-item__price.price').innerHTML = html.querySelector(".product-grid-item__price.price").innerHTML;
      container.querySelector('.product-inventory__quantity .inventory__quantity').innerHTML = html.querySelector('.product-inventory__quantity .inventory__quantity').innerHTML;
      const productSizes = container.querySelector('.product-size__swatch-container');
      const newSizes = html.querySelector('.product-size__swatch-container');

      const sizeSelectedValue = html.querySelector('.selected-size__value');          
           
      const containerSizeSelectedValue = container.querySelector('.selected-size__value');
      if (productSizes && !sizeOption && newSizes) {
        productSizes.innerHTML = newSizes.innerHTML;        
      }
      if (containerSizeSelectedValue) {
        containerSizeSelectedValue.innerHTML = sizeSelectedValue.innerHTML;
      }
      const mobileAtc = container.querySelector('.product-addtocart__container');
      if (mobileAtc) {
        mobileAtc.innerHTML = html.querySelector('.product-addtocart__container').innerHTML;
      } 
      const inventoryQuantityEle = container.querySelector('.product-inventory__quantity')
      const inventoryQuantity = parseInt(html.querySelector('.product-inventory__quantity .inventory__quantity').innerHTML);
      if (inventoryQuantity > 0 && inventoryQuantity <= 5) {
        inventoryQuantityEle.classList.remove('hidden')
      }else {
        inventoryQuantityEle.classList.add('hidden')
      }
    })
    .catch((error) => {
      console.error('Error fetching product data:', error);
    }).finally(() => {
      if (!sizeOption) {
        container.querySelectorAll('[aria-selected="true"]')?.forEach((each) => each.setAttribute('aria-selected', 'false'));
        target.setAttribute('aria-selected', 'true');
      }
    });
}


function updateCartIconBubble(bubble, count) {
  if (bubble) {
    console.log("updateCartIconBubble")
    const html = new DOMParser().parseFromString(bubble, "text/html")
    document.querySelectorAll('#cart-icon-bubble').forEach((each) => {
      each.innerHTML = html.querySelector('#cart-icon-bubble').innerHTML;
    })
  }
  if (count !== null && count !== undefined) {
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble').forEach((each) => {
      each.textContent = count;
      if (count == 0) each.classList.add('d-none')
      else each.classList.remove('d-none')
    })
  }
}

/* PRODUCT CARD SIZE VARIANTS */

class ProductSizeVariant extends HTMLElement {
  constructor() {
    super();

    this.currentCollectionHandle = document.querySelector('.product-grid-item__details')?.dataset?.currentCollectionHandle;
    

    this.addEventListener('click', (event) => {
      if (event.target.closest('.product-size__swatch-button')) {
        const sizeOption = event.target.closest('.product-size__swatch-button');
        
        this.updateProductCardSizes(sizeOption);
        this.updateDropdownElements(sizeOption);
      }
    });
  }

  updateProductCardSizes(eachSize) {    
    const sizeOptions = this.querySelectorAll('.product-variant-options')
    const selectedSizeOption = eachSize.querySelector('.product-variant-options');
    sizeOptions.forEach((each) => {
      each?.classList.remove('selected');
    });
    selectedSizeOption?.classList.add('selected');
    // Passing true while calling fetchProductData so it won't effect color swatches 
    fetchProductData(eachSize, true , this.currentCollectionHandle);
  }  

  updateDropdownElements(sizeOption) {
    const selectedValue = sizeOption.querySelector('.product-size__text').innerHTML;    
    const sizeDropdownEle = sizeOption.closest('.product-size-variants__dropdown');
    const selectedSizeEle = sizeDropdownEle.querySelector('.selected-size__value');

    if (selectedSizeEle) {
      selectedSizeEle.innerHTML = selectedValue ;
    }
    sizeDropdownEle?.classList.remove('is-active');
  }
}
customElements.define('product-size-variant', ProductSizeVariant);


//=================================================
// functionality for read more button implementation
// ================================================
class productSpecification extends HTMLElement {
  constructor() {
    super();
    this.readMoreBtn = this.querySelector("#showMoreBtn");
    this.readMoreBtn.addEventListener('click',() => {
      this.showMore();
    })
  }

  showMore() {
    this.showMoreTexts = document.querySelectorAll('.read__more--btn');
    this.showMoreTexts.forEach((text) => {
      text.classList.toggle('hidden');
    })
  }
}
customElements.define('product-specification', productSpecification);

// to fix the glitch
let intervalForGlitch = setInterval(function(){
  document.querySelector("#moe-dontallow_button")?.addEventListener("click",function(){
    document.querySelector("body").classList.remove("overflow-hidden","js-drawer-open");
    clearInterval(intervalForGlitch);
  })
}, 100);

// SEARCH page input clear function
const searchInputClearBtn = document.querySelector("#SearchPage .search-popdown__close")
searchInputClearBtn?.addEventListener("click",() => {
  const searchInput = document.querySelector("#SearchPage #searchInput-SearchPage")
  searchInput.value = '';
  searchInput.focus();
})

// PLP Sticky Sort options based on header height
function stickyElements() {
  setTimeout(() => {
    const headerHeight = document.querySelector('#SiteHeader .wrapper').offsetHeight + 50;
    const announcementBarHeight = document.querySelector('.announcement-bar-static')?.offsetHeight || 0;
    const CollectionFilters = document.querySelector('.collection__filters')
    const stonyBrookCollectionFilters = document.querySelector('.stony-brook_filter__options');
    const wizzySearchWrapper = document.querySelector('.wizzy-autocomplete-wrapper');
    const careerStickyNav = document.querySelector('.career-sticky-nav-container');
    if (CollectionFilters && window.innerWidth > 768) {
      CollectionFilters.style.top = (headerHeight + 33) + "px";
    }
    if (stonyBrookCollectionFilters && window.innerWidth > 768) {
      stonyBrookCollectionFilters.style.top = (headerHeight - 2) + "px";
    }
    if(wizzySearchWrapper) {
      wizzySearchWrapper.style.top = (headerHeight + 35) + "px";
    }
    if (careerStickyNav) {
      let lastScrollTop = 0;
      careerStickyNav.style.top = (headerHeight + announcementBarHeight - 3) + "px";

      window.addEventListener('scroll', () => {
        const currentAnnouncementBarHeight = document.querySelector('.announcement-bar-static')?.offsetHeight || 0;
        console.log("height",currentAnnouncementBarHeight)
        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScrollTop > lastScrollTop && window.innerWidth < 767) {
          careerStickyNav.style.top = "0px";
        } else {
          careerStickyNav.style.top = (headerHeight + currentAnnouncementBarHeight - 3) + "px";
        }
        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
      });
    }
  }, 1000);
}
stickyElements();

// Product reviews section navigation when click on ratings
const productsRatings = document.querySelectorAll('.product-reviews__navigation')
const reviewsContainer = document.querySelector('#opinew-reviews-product-page-code')
productsRatings?.forEach((eachEle) => {
  eachEle?.addEventListener("click",() => {
    const distanceToTop = (reviewsContainer.offsetTop) - 200
    window.scrollTo({
      top: distanceToTop,
      left: 0,
      behavior: 'smooth',
    });
  })
})


// GIFT CARD Shopify checkout
class GiftCardCheckout extends HTMLElement {
  constructor() {
    super();
    this.giftCardCheckboxInput = this.querySelector('.gift-card-checout__input');
    this.giftCardCheckbox();

    setTimeout(() => {
      this.init(this.giftCardCheckboxInput);
    }, 1000);
  }

  init(giftCardCheckboxInput) {
    const cartPaymentContainer = giftCardCheckboxInput.closest('.cart__foot-inner') || giftCardCheckboxInput.closest('.product__submit__holder')
    if (giftCardCheckboxInput.checked) {
      cartPaymentContainer?.classList.add('native-checkout');
    } else {
      cartPaymentContainer?.classList.remove('native-checkout');
    }
  }
  giftCardCheckbox() {
    this.giftCardCheckboxInput?.addEventListener('click', () => {
      this.init(this.giftCardCheckboxInput);
    })
  }
}
customElements.define('gift-card-checkout', GiftCardCheckout);


// Collection page grid view options
class ProductGridOptions extends HTMLElement {
constructor() {
  super();
    this.gridViewButtons = this.querySelectorAll('.grid-view__option');
    this.gridViewButtons.forEach((eachButton) => {
      eachButton?.addEventListener('click', () => {
        this.changeGridView(eachButton);
      })
    })
  }

  changeGridView(eachButton) {
    const collectionProductsElement = document.querySelector('.collection__products');
    const gridViewValue = eachButton.getAttribute('data-grid-option')
    this.gridViewButtons.forEach((each)=> {
      each.classList.remove('active-grid')
    })
    eachButton.classList.add('active-grid');
    if (collectionProductsElement.classList.contains('three-grid-view')) {
      collectionProductsElement.classList.remove('three-grid-view')
    } else if (collectionProductsElement.classList.contains('two-grid-view')) {
      collectionProductsElement.classList.remove('two-grid-view')
    }else if (collectionProductsElement.classList.contains('one-grid-view')) {
      collectionProductsElement.classList.remove('one-grid-view')
    }
    collectionProductsElement.classList.add(`${gridViewValue}-grid-view`)
  }
}
customElements.define('product-grid-options', ProductGridOptions);

// PDP Availble and coupons
const availbleOffersCouponsEle = document.querySelector('.all-offer_and_coupons__title');
const availableCouponsContainer = availbleOffersCouponsEle?.closest('.offer_and_coupons__wrapper');
const offersWrapper = availableCouponsContainer?.querySelector('.available-and-bank-offer__wrapper');
const ismobile = window.matchMedia("(max-width: 767px)").matches;

if (offersWrapper && !ismobile) {
  offersWrapper.style.height = 'auto';
  var fullHeight = offersWrapper.getBoundingClientRect().height;
  offersWrapper.style.height = '0';
}
availbleOffersCouponsEle?.addEventListener('click', () =>{
  availableCouponsContainer?.classList.toggle('show-offers');

  if (!ismobile) {
    if (!availableCouponsContainer.classList.contains('show-offers')) {
      offersWrapper.style.height = '0';
    } else {
      offersWrapper.style.height = fullHeight + 25 + 'px';
    }
  }

  if (ismobile) {
    document.querySelector('body').classList.toggle('overflow-hidden');
    const overlay = document.querySelector('.drawer__overlay');
    overlay?.classList.toggle('show-offers');
  }
});

const offersPopupCloseEle = document.querySelector('.offer-and-coupons-close__button');
offersPopupCloseEle?.addEventListener('click', () =>{
  const availableCouponsEle = offersPopupCloseEle.closest('.offer_and_coupons__wrapper');
  availableCouponsEle?.classList.remove('show-offers');
  document.querySelector('body').classList.remove('overflow-hidden');
  const overlay = document.querySelector('.drawer__overlay');
  overlay?.classList.remove('show-offers');
});

/* PDP available and bank offers Blocks */
const specialOffersContainers = document.querySelectorAll('.available-offers--container');
let flickityInstances = [];  // To store Flickity instances

// Function to initialize Flickity on desktop and destroy on mobile
function handleFlickityInit() {
  const isDesktop = window.matchMedia("(min-width: 768px)").matches;

  specialOffersContainers?.forEach((each, index) => {
    if (isDesktop) {
      // If on desktop and Flickity is not initialized, initialize it
      if (!flickityInstances[index]) {
        flickityInstances[index] = new Flickity(each, {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: true,
          pageDots: false,
        });
      }
    } else {
      // If on mobile and Flickity is initialized, destroy it
      if (flickityInstances[index]) {
        flickityInstances[index].destroy();
        flickityInstances[index] = null;
      }
    }
  });
}

// Run on initial load
handleFlickityInit();

// Listen for screen resize events to handle Flickity re-initialization
window.addEventListener('resize', handleFlickityInit);


/* PDP section Navigation */
const navigationElements = document.querySelectorAll('.navigation__item')
navigationElements?.forEach((eachButton) => {
  eachButton?.addEventListener('click', () => {
    const navigationId = eachButton.getAttribute('data-navigation-section');
    if (navigationId) {
      const navigationSection = document.querySelector(`${navigationId}`);
      if (navigationSection) {
        const rect = navigationSection.getBoundingClientRect();
        const distanceFromTop = (rect.top + window.scrollY) - 100;
        window.scrollTo({
          top: distanceFromTop,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  })
})

/* PDP size chart */
 const sizeChartButton = document.querySelector('#sizeChartButton');
 const sizeChartContainer = document.querySelector('.product-size-chart__container');
 const sizeChartOverlay = document.querySelector('.size-chart-overlay');
 const sizeChartCloseButton = document.querySelector('.size-chart__close');
 const bodyElement = document.querySelector('body');
 sizeChartButton?.addEventListener('click',() => {
  sizeChartContainer?.classList.add('show-size-chart');
  sizeChartOverlay?.classList.add('show-size-chart');
  bodyElement.classList.add('overflow-hidden');
 })

 sizeChartCloseButton?.addEventListener('click',() => {
  sizeChartContainer?.classList.remove('show-size-chart');
  sizeChartOverlay?.classList.remove('show-size-chart');
  bodyElement.classList.remove('overflow-hidden');
 })

/* Shoppable videos section */
class ShoppableVideos extends HTMLElement {
  constructor() {
    super();
    this.init();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  init() {
    this.shoppableSlider = this;
    this.initializeSlider();
    this.autoplayVideos();
  }

  initializeSlider() {
    // Set alignment based on current viewport width
    let cellAlignment = window.innerWidth > 767 ? 'left' : 'center';

    // Destroy existing Flickity instance if it exists
    if (this.flkty) {
      this.flkty.destroy();
    }

    // Initialize Flickity
    this.flkty = new Flickity(this.shoppableSlider, {
      cellAlign: cellAlignment,
      contain: true,
      pageDots: false,
      groupCells: true
    });
  }

  autoplayVideos() {
    // Autoplay Videos in iOS
    this.shoppableVideoEle = this.querySelectorAll('.shoppable-video-element');
    this.shoppableVideoEle.forEach((video) => {
      video.muted = true;
      video.playsInline = true; // Required for inline play on iOS
      video.play().catch((error) => {
        console.log('Video playback failed: ' + error);
      });
    });
  }

  handleResize() {
    // Check if the viewport width crossed the 767px threshold
    let isDesktop = window.innerWidth > 767;
    let wasDesktop = this.flkty && this.flkty.options.cellAlign === 'left';

    if ((isDesktop && !wasDesktop) || (!isDesktop && wasDesktop)) {
      // Reinitialize the slider with the updated alignment setting
      this.initializeSlider();
    }
  }
}
customElements.define('shoppable-videos', ShoppableVideos);

/* PDP videos section */
class ProductVideos extends HTMLElement {
  constructor() {
    super();
    this.init();
    window.addEventListener('resize', this.handleResize.bind(this)); // Attach resize listener
  }

  init() {
    this.videoSlider = this;
    this.checkAndInitializeSlider();
    this.autoplayVideos();         
  }

  checkAndInitializeSlider() {
    const childCount = this.videoSlider.querySelectorAll('.pdp-feature-videos__wrapper').length;
    const isDesktop = window.innerWidth > 767;
    const threshold = isDesktop ? 4 : 2;

    if (childCount > threshold) {
      this.initializeSlider(); // Apply carousel if child count exceeds the threshold
    } else {
      this.destroySlider();
    }
  }

  initializeSlider() {
    // Set alignment based on viewport width
    let alignment = window.innerWidth > 767 ? 'left' : 'center';

    // Destroy Flickity instance if it already exists
    if (this.flkty) {
      this.flkty.destroy();
    }

    // Initialize Flickity with alignment and other options
    this.flkty = new Flickity(this.videoSlider, {
      cellAlign: alignment,
      contain: true,
      pageDots: false,
      groupCells: true
    });
  }

  destroySlider() {
    if (this.flkty) {
      this.flkty.destroy();
      this.flkty = null;
    }
  }

  autoplayVideos() {
    // Autoplay videos in iOS and other supported devices
    const pdpVideoEle = this.querySelectorAll('.pdp-video-element');
    pdpVideoEle.forEach((video) => {
      video.load();
      video.muted = true;
      video.playsInline = true;
      video.play().catch((error) => {
        console.log('Video playback failed: ' + error);
      });
    });
  }

  handleResize() {
    this.checkAndInitializeSlider(); // Recheck and initialize or destroy the slider on resize
  }
}
customElements.define('product-videos-carousel', ProductVideos);


const accountPageBackButton = document.querySelector('.back-to-account');
accountPageBackButton?.addEventListener('click', function() {
  window.history.back();
});

// PDP Available Offers 
const copyCodeButtons = document.querySelectorAll('.offer-copy-code__button')
copyCodeButtons.forEach((each)=> {
  each.addEventListener('click',()=> {
    var couponCode = each.getAttribute("data-coupon")
    copyTextToClipboardPdp(couponCode,each);
  })
});

function copyTextToClipboardPdp(str, button) {
  if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
    const copyCodeButtonsText = document.querySelectorAll('.offer-copy-code__button span');
    copyCodeButtonsText.forEach((each) => {each.innerHTML = "Copy Code"});
    const buttonText = button.querySelector('span');
    button.style.pointerEvents = "none";
    buttonText.innerHTML = "Copied"

    var removeToast = setInterval(() => {
      button.style.pointerEvents = "all";
      clearInterval(removeToast);
    }, 1500);

    return navigator.clipboard.writeText(str);
  }

  return Promise.reject('The Clipboard API is not available.');
}

const menuDrawerButton = document.querySelector('.mobile-navigation__item[data-menu-drawer-toggle]');
menuDrawerButton?.addEventListener('click', ()=>{
  const navDrawer = document.querySelector('#nav-drawer');
  navDrawer.classList.add('is-open');
  document.querySelector('body').classList.add('js-drawer-open');
  document.dispatchEvent(
    new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: navDrawer })
  )
  document.dispatchEvent(new CustomEvent("theme:drawer:open"), {
    bubbles: !0,
  })
})

let lastScrollTop = 0;
let scrollDirection = ''; // Track scroll direction

window.addEventListener('scroll', function() {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const header = document.querySelector('#SiteHeader');
  const announcementBar = document.querySelector('.announcement-bar-static');

  // Scroll direction check based on showing header and mobile menu
  if (scrollTop > 150 && window.innerWidth < 768) {
    if (scrollTop > lastScrollTop) {
      scrollDirection = 'down';
      document.body.classList.add('shopify-body-section-header-sticky');
      header.classList.remove('sticky-header-active');
      header.classList.add('hide-sticky-header');
      announcementBar?.classList.add('hide-sticky-announcementbar');
      announcementBar?.classList.remove('sticky-announcementbar-active');
    } else {
      scrollDirection = 'up';
      document.body.classList.remove('shopify-body-section-header-sticky');
      header.classList.add('sticky-header-active');
      header.classList.remove('hide-sticky-header');
      announcementBar?.classList.add('sticky-announcementbar-active');
      announcementBar?.classList.remove('hide-sticky-announcementbar');
    }
  } else {
    header.classList.remove('sticky-header-active');
    header.classList.remove('hide-sticky-header');
    announcementBar?.classList.remove('sticky-announcementbar-active');
    announcementBar?.classList.remove('hide-sticky-announcementbar');
  }

  // Update last scroll position
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});

const closeAnnouncementBar = document.querySelector('.announcement-bar__close');
closeAnnouncementBar?.addEventListener('click', () => {
  document.body.classList.add('hide-announcement-bar');
})

/* notify me whatsapp notification */
const notifymeButton = document.querySelector('.whatsapp-notifyme--button');
const notifymeContainer = document.querySelector('.whatsapp-notifyme--container');
const notifymeCloseButton = document.querySelector('.close-notifyme-form')
notifymeButton?.addEventListener('click', () => {
  notifymeContainer?.classList.add('show-notifyme-popup');
});

notifymeCloseButton?.addEventListener('click', () => {
  notifymeContainer?.classList.remove('show-notifyme-popup');
});

// personalised luggage tags
const modal = document.querySelector("#customizer-Modal");
const customizeButton = document.querySelector("#customizer-button");
const customizeCloseBtn = document.getElementsByClassName("customizer_close")[0];
const mainProductTemplate = document.querySelector('.shopify-section--product');

// When the user clicks the button, open the modal 
customizeButton?.addEventListener('click', () => {
  modal.classList.remove('hidden');
  document.querySelector('body').classList.add('overflow-hidden');
  mainProductTemplate.classList.add('popup-visible');
}) 

// When the user clicks on (x), close the modal
customizeCloseBtn?.addEventListener('click', () => {
  modal.classList.add('hidden');
  document.querySelector('body').classList.remove('overflow-hidden');
  mainProductTemplate.classList.remove('popup-visible');
})

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.classList.add('hidden');
    document.querySelector('body').classList.remove('overflow-hidden');
    mainProductTemplate.classList.remove('popup-visible');
  }
  if (!event.target.closest('.product-size-variants__dropdown')) {
    const dropdownList = document.querySelectorAll('.product-size-variants__dropdown');
    dropdownList?.forEach((each) => each.classList.remove('is-active'));
  }
}

// SIZE VARIANTS DROPDOWN
class productCardVariants extends HTMLElement {
  constructor() {
    super();
    this.selectSizeElement = this.querySelector('.selected-size__container');
    this.selectSizeElement?.addEventListener('click', () => {
      this.showSizsDropdown(this.selectSizeElement);
    });
  }
  showSizsDropdown(each) {
    this.dropdown = each.closest('.product-size-variants__dropdown');
    // Check if this dropdown is already open
    const isActive = this.dropdown.classList.contains('is-active');
    
    // Remove 'is-active' class from all dropdowns
    document.querySelectorAll('.product-size-variants__dropdown.is-active')?.forEach((openDropdown) => {
      openDropdown.classList.remove('is-active');
    });

    // Toggle only if it wasn't already active
    if (!isActive) {
      this.dropdown.classList.add('is-active');  // Open the clicked dropdown if it wasn't already active
    }
    
  }
}
customElements.define('product-card-variants', productCardVariants);

// PLP Shop By Color View More Button 
document.addEventListener('click',(event) => {
  if (event.target.hasAttribute('data-color-open-filter')){
    const collectionFilters = document.querySelector('[data-collection-filters]');
    if (collectionFilters) {
      collectionFilters.classList.add('collection__filters--visible');
      const colorFilterTiggerBtn = collectionFilters.querySelector('[data-color-swatches-trigger]');
      const colorFilterSwatches = collectionFilters.querySelector('[data-color-swatches]');

      colorFilterTiggerBtn?.classList.add('is-expanded');
      colorFilterSwatches?.classList.add('is-expanded');
      colorFilterSwatches.style.height = 'auto';
    }
  }
})

// document.addEventListener('submit', function(e) {

//   const form = e.target;

//   if (form.matches('form[action="/cart/add"]')) {

//     e.preventDefault();

//     const formData = new FormData(form);

//     fetch('/cart/add.js', {
//       method: 'POST',
//       body: formData
//     })
//     .then(res => res.json())
//     .then(() => {

//       // update cart bubble if needed
//       fetch('/cart?view=drawer')
//       .then(r => r.text())
//       .then(html => {

//         const drawer = document.querySelector('#cart-drawer');

//         if(drawer){
//           drawer.classList.add('is-open');
//           document.body.classList.add('js-drawer-open');
//         }

//       });

//     })
//     .catch(err => console.error(err));
//   }

// });

// document.addEventListener("submit", function(e) {

//   const form = e.target;

//   if (form.action.includes("/cart/add")) {

//     e.preventDefault();

//     const formData = new FormData(form);

//     fetch("/cart/add.js", {
//       method: "POST",
//       body: formData
//     })
//     .then(res => res.json())
//     .then(() => {

      

//       const drawer = document.querySelector("#cart-drawer");
//       if(drawer){
//         drawer.classList.add("is-open");
//         document.body.classList.add("js-drawer-open-cart");
//         drawer.classList.remove("cv-h");
//       }

//     })
//     .catch(err => console.error(err));
//   }

// });


